module.exports = __webpack_public_path__ + "img/mockup-nancy-open-air.d5f182e.png";